import axiosServerGolang from '@/configs/axiosServerGolang'

export default {
  async fetchPopularKeyword (_, accessToken) {
    try {
      const { data } = await axiosServerGolang({
        method: 'get',
        url: '/discovery/popular-keywords',
        headers: {
          Authorization: accessToken || process.env.VUE_APP_APP_KEY
        }
      })
      return data
    } catch (error) {
      throw error
    }
  },
  async fetchSearchProgramRecommendation (_, accessToken) {
    try {
      const { data } = await axiosServerGolang({
        method: 'get',
        url: '/discovery/program-ads/prakerja',
        headers: {
          Authorization: accessToken || process.env.VUE_APP_APP_KEY
        }
      })
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  },
  async fetchSearchInstitutionRecommendation (_, accessToken) {
    try {
      const { data } = await axiosServerGolang({
        method: 'get',
        url: '/discovery/institution-ads/prakerja',
        headers: {
          Authorization: accessToken || process.env.VUE_APP_APP_KEY
        }
      })
      return data
    } catch (err) {
      console.error(err)
      throw err
    }
  }
}
